import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'EdiaryWebApp';
  cssUrl: string;
  cssTheme: string;

  constructor(public sanitizer: DomSanitizer) {
    // this.cssUrl = '/assets/theme/info.css';
    this.cssTheme = 'info';
    //this.cssUrl='ediary/assets/theme/info.css';
    //this.cssTheme='info';
    // this.cssTheme='primary';
    // this.cssTheme='secondary';
    // this.cssTheme='danger';
  }

  @HostListener('window:onbeforeunload', ['$event'])
  clearLocalStorage(event) {
    localStorage.clear();
  }

  ngOnInit() {}
}
